import { ElementCategoryData } from '@wix/editor-platform-sdk-types';
import {
  CategoryWithItems,
  FullNormalizedItem,
  SectionsItems,
} from '@wix/editor-platform-host-integration-apis';

const getCategoryWithItems = (
  categoryId: string,
  data: ElementCategoryData[],
  child: FullNormalizedItem,
): CategoryWithItems => {
  const categoryIndex = data.findIndex(({ id }) => id === categoryId);

  if (categoryIndex >= 0) {
    return {
      ...data[categoryIndex],
      categoryIndex,
      children: [child],
    };
  }

  return {
    id: '',
    categoryIndex,
    children: [child],
  };
};

export const addCategoriesChildrenItem = (
  item: FullNormalizedItem,
  data: ElementCategoryData[],
  categoriesWithItems: SectionsItems['categoriesWithItems'],
): SectionsItems['categoriesWithItems'] => {
  const categoryId = item.categoryId;

  if (!categoryId) {
    return categoriesWithItems;
  }

  const category = categoriesWithItems[categoryId];

  return {
    ...categoriesWithItems,

    [categoryId]: category
      ? { ...category, children: [...category.children, item] }
      : getCategoryWithItems(categoryId, data, item),
  };
};
